import styled from 'styled-components';

export const PodcastContainer = styled.div`
  max-width: 1200px;
`;

export const Subtitle = styled.h2`
  margin-bottom: 1rem;
`;

export const PodcastInfo = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr;
  grid-gap: 3rem;
  max-width: 1000px;
  margin-bottom: 5rem;
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
`;
